/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1PersonIdStudentDataQueryResponse,
  GetApiV1PersonIdStudentDataPathParams,
  GetApiV1PersonIdStudentData401,
  GetApiV1PersonIdStudentData404,
  GetApiV1PersonIdStudentData500,
} from "../../types/personStudentController/GetApiV1PersonIdStudentData.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1PersonIdStudentData } from "../../clients/personStudentController/getApiV1PersonIdStudentData.ts";

export const getApiV1PersonIdStudentDataQueryKey = (
  id: GetApiV1PersonIdStudentDataPathParams["id"],
) => [{ url: "/api/v1/person/:id/student-data", params: { id: id } }] as const;

export type GetApiV1PersonIdStudentDataQueryKey = ReturnType<
  typeof getApiV1PersonIdStudentDataQueryKey
>;

export function getApiV1PersonIdStudentDataQueryOptions(
  id: GetApiV1PersonIdStudentDataPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1PersonIdStudentDataQueryKey(id);
  return queryOptions<
    GetApiV1PersonIdStudentDataQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonIdStudentData401
      | GetApiV1PersonIdStudentData404
      | GetApiV1PersonIdStudentData500
    >,
    GetApiV1PersonIdStudentDataQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1PersonIdStudentData(id, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna os dados da aba Student da pessoa (RA, USP, currículo, perfil público e campos de graduação finalizada). **(Requer Authorization para autenticação)**
 * @summary Obter dados de aluno (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/student-data}
 */
export function useGetApiV1PersonIdStudentData<
  TData = GetApiV1PersonIdStudentDataQueryResponse,
  TQueryData = GetApiV1PersonIdStudentDataQueryResponse,
  TQueryKey extends QueryKey = GetApiV1PersonIdStudentDataQueryKey,
>(
  id: GetApiV1PersonIdStudentDataPathParams["id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1PersonIdStudentDataQueryResponse,
        ResponseErrorConfig<
          | GetApiV1PersonIdStudentData401
          | GetApiV1PersonIdStudentData404
          | GetApiV1PersonIdStudentData500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1PersonIdStudentDataQueryKey(id);

  const query = useQuery(
    {
      ...getApiV1PersonIdStudentDataQueryOptions(id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1PersonIdStudentData401
      | GetApiV1PersonIdStudentData404
      | GetApiV1PersonIdStudentData500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
